export default __webpack_public_path__ + "static/media/ImgAttachment.1a1c8ede.jpg";